import { UploadTariffDocumentResponse } from '@core/data-access/models/api/upload-tariff-document.model';
import { FileKind, FileType, UploadedFile } from '@core/data-access/models/file-upload.model';
import { zipWith } from 'lodash';

export const mapUploadTariffDocumentResponseToUploadedFiles = (
  fileKind: FileKind,
  files: File[],
  uploadTariffDocumentResponse: UploadTariffDocumentResponse
) =>
  zipWith(files, uploadTariffDocumentResponse.tariffDocumentIds, (file, id): UploadedFile => ({
    id,
    name: file.name,
    kind: fileKind,
    size: file.size,
    type: file.type as FileType
  }));
